module.exports = __webpack_public_path__ + "img/deposit.e2485989.svg";